import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/setting/landing-schedule-images`;

const getLandingScheduleImages = async (params) => {
  return await axios.get(API_URL, { params });
};

/**
 * Upsert one image for year/month/isAir (replaces existing row for same key).
 * @param {{ year: number, month: number, isAir: boolean, file: File }} payload
 */
const upsertLandingScheduleImage = async ({ year, month, isAir, file }) => {
  const formData = new FormData();
  formData.append('year', String(year));
  formData.append('month', String(month));
  formData.append('isAir', isAir ? 'true' : 'false');
  formData.append('image', file);
  return await axios.post(API_URL, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

const deleteLandingScheduleImage = async (id) => {
  return await axios.delete(`${API_URL}/${id}`);
};

export default {
  getLandingScheduleImages,
  upsertLandingScheduleImage,
  deleteLandingScheduleImage,
};
